import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { wz } from '../../components/wizard-tokens';
import { WizAddChip, WizChip, WizInlineInput } from '../../components/wizard-ui';
import { addChipValue, removeChipValue } from './candidates-logic';

interface Props {
  label: string;
  values: string[];
  editing: boolean;
  onChange: (values: string[]) => void;
}

/** Zeile „Jobtitel“ / „Erfahrung“ / „Sprache“: Chips, nach „Anpassen“ mit × und Eingabe. */
const CriteriaRow: React.FC<Props> = ({ label, values, editing, onChange }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState('');

  const commit = (text: string, keepOpen: boolean) => {
    const next = addChipValue(values, text);
    if (next !== values) onChange(next);
    setDraft('');
    setAdding(keepOpen && text.trim() !== '');
  };

  return (
    <div className={classes.row}>
      <div className={classes.label}>{label}</div>
      <div className={classes.chips}>
        {values.map((v, i) => (
          <WizChip
            key={`${v}-${i}`}
            variant="blue"
            onRemove={editing ? () => onChange(removeChipValue(values, i)) : undefined}
          >
            {v}
          </WizChip>
        ))}
        {values.length === 0 && !editing ? (
          <span className={classes.empty}>{t('wizCandCriteriaEmpty')}</span>
        ) : null}
        {editing ? (
          adding ? (
            <WizInlineInput
              value={draft}
              placeholder={t('wizCandCriterionPlaceholder')}
              width={170}
              onChange={setDraft}
              onEnter={v => commit(v, true)}
              onEscape={() => {
                setDraft('');
                setAdding(false);
              }}
              onBlur={v => commit(v, false)}
            />
          ) : (
            <WizAddChip label={t('wizCandAddCriterion')} onClick={() => setAdding(true)} />
          )
        ) : null}
      </div>
    </div>
  );
};

const useStyles = makeStyles()({
  row: { display: 'flex', alignItems: 'center', gap: 12 },
  label: { width: 160, fontSize: 14, color: wz.muted, flexShrink: 0 },
  chips: { display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' },
  empty: { fontSize: 13, color: wz.muted },
});

export default CriteriaRow;
